const LOGO_SIGN_MARKER = '/object/sign/propertycut-uploads/';

/** Path of a logo this person uploaded, or null for any other URL. */
export function logoStoragePath(url: string | null | undefined, userId: string): string | null {
  if (!url) return null;
  const idx = url.indexOf(LOGO_SIGN_MARKER);
  if (idx === -1) return null;
  let path: string;
  try {
    path = decodeURIComponent(url.slice(idx + LOGO_SIGN_MARKER.length).split('?')[0]);
  } catch {
    return null;
  }
  const parts = path.split('/');
  if (parts.length < 3 || parts[0] !== 'logos' || parts[1] !== userId) return null;
  if (parts.some((part) => part === '..' || part === '')) return null;
  return path;
}
